import React from 'react';
import { AccordionV2 as Accordion, AccordionDropdown } from '@beef/legacy-ui-kit';
import PropTypes from 'prop-types';

/**
 * An accordion container for SectionGroup
 */
export const SectionGroup = ({ children, className }) => {
  return (
    <Accordion className={className} isFlat>
      {children}
    </Accordion>
  );
};

SectionGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

/**
 * Section is simply parametrized accordion item
 */
export const Section = ({ className, ...props }) => {
  return <AccordionDropdown {...props} className={className} />;
};

Section.propTypes = {
  children: PropTypes.node, // inheritedProps
  className: PropTypes.string,
  isOpen: PropTypes.bool, // inheritedProps
  onToggle: PropTypes.func, // inheritedProps
  title: PropTypes.node, // inheritedProps
};

Section.defaultProps = {
  isOpen: null,
};
